import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  min-height: 100vh;
  min-width: 100vw;
  display: ${({ isModalOpen }) => !isModalOpen && 'none'};
  text-decoration: none;
  background: hsl(0, 0%, 60%, 0.7);
`;

const ModalMenu = styled.div`
  display: flex;
  flex-direction: column;
  height: 50vh;
  width: 40vw${({ screenWidth }) =>
    screenWidth < 992 ? '50vw' : '40vw'};
  background: white;
  border: 3px solid #f09b87;
  border-radius: 1rem;
  padding: 1rem;
  overflow-y: scroll;
  ::-webkit-scrollbar {
    width: 0;
  }
  .modal__header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .modal__title {
      display: flex;
      align-items: center;
      font-size: 1.5rem;
      font-weight: bold;
    }
  }

  ul {
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    button {
      border: none;
    }
  }

  li {
    width: 33%;
    padding: 0.1rem;
  }
`;

const Villager = styled.div`
  display: flex;
  align-items: center;
  padding: 0.5rem;
  padding-top: 0;
  img {
    height: 44px;
    width: 44px;
    border-radius: 0.4rem;
  }
  span {
    margin-left: 2rem;
    font-weight: bold;
  }
`;

const MiddleButton = styled.button`
  background: linear-gradient(to bottom right, #f08080, #fbb994);
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  color: white;
  border: none;
  font-size: 1rem;
  font-weight: bold;
  width: 120px;
  align-self: center;
  letter-spacing: 1px;
  height: 2.25rem;
  padding: 0.5rem;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  margin: 0.5rem;
`;

const ConfirmButton = styled.button`
  background: linear-gradient(to bottom right, #f08080, #fbb994);
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  color: white;
  border: none;
  font-size: 1rem;
  font-weight: bold;
  width: 150px;
  align-self: center;
  letter-spacing: 1px;
  height: 2.25rem;
  padding: 0.5rem;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  margin: 0.5rem;
`;

const ValidText = styled.p`
  color : green;
`

const InvalidText = styled.p`
  color : red;
`

export { ModalMenu, Villager, MiddleButton, ConfirmButton, InvalidText };

export default Container;
